export default __webpack_public_path__ + "static/media/10458-ekcs.d5881a5f.pdf";